import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ResearchComponent} from "./research.component";
import {ResearchPoliciesComponent} from "./research-policies/research-policies.component";
import {ResearchPublicationComponent} from "./research-publication/research-publication.component";

const routes: Routes = [
    {path: 'research-overview', component: ResearchComponent, data: {title: 'Research Overview'}},
    {path: 'phd-programme', component: ResearchComponent, data: {title: 'Ph.D. Programme'}},
    {path: 'ipr-cell', component: ResearchComponent, data: {title: 'IPR Cell'}},
    {
        path: 'research-paper',
        component: ResearchComponent,
        data: {title: 'Research Paper'},
    },
    {
        path: 'research-projects',
        component: ResearchComponent,
        data: {title: 'Research Projects'},
    },
    {
        path: 'patents-and-copyright',
        component: ResearchComponent,
        data: {title: 'Patents & Copyright'},
    },
    {
        path: 'phd-regulations',
        component: ResearchComponent,
        data: {title: 'Ph.D. Regulations'},
    },
    {
        path: 'collaborations-or-mou',
        component: ResearchComponent,
        data: {title: 'Collaborations/MOUs'},
    },
    {
        path: 'conference-or-workshop',
        component: ResearchComponent,
        data: {title: 'Conference/Workshop'},
    },
    {
        path: 'downloads',
        component: ResearchComponent,
        data: {title: 'Downloads'},
    },
    {
        path: 'ipr-policy',
        component: ResearchPoliciesComponent,
        data: {title: 'IPR Policy'},
    },
    {
        path: 'promotion-policies',
        component: ResearchPoliciesComponent,
        data: {title: 'Research Promotion Policy'},
    },
    {
        path: 'downloads',
        component: ResearchComponent,
        data: {title: 'Downloads'},
    },
    {
        path: 'ipr-policy',
        component: ResearchPoliciesComponent,
        data: {title: 'IPR Policy'},
    },
    {
        path: 'promotion-policies',
        component: ResearchPoliciesComponent,
        data: {title: 'Research Promotion Policy'},
    },
    {
        path: 'research-paper-publication',
        component: ResearchPublicationComponent,
        data: {title: 'Research Paper Publication'},
    },
    {
        path: 'book-publication-details',
        component: ResearchPublicationComponent,
        data: {title: 'Book Publication Details'},
    },
    {
        path: 'book-chapters-publication',
        component: ResearchPublicationComponent,
        data: {title: 'Book Chapters Publication'},
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ResearchRoutingModule {
}
